import {PaginationMeta} from "./pagination.model";

export interface ApiResponse<T> {
    status: ResponseStatus
    message: string
    body: T;
    pagination?: PaginationMeta;
}

export enum ResponseStatus {
    SUCCESS = 'SUCCESS',
    BAD_REQUEST = 'BAD_REQUEST',
    UNAUTHORIZED = 'UNAUTHORIZED',
    FORBIDDEN = 'FORBIDDEN',
    NOT_FOUND = 'NOT_FOUND',
    SERVER_ERROR = 'SERVER_ERROR'
}